import React, { Component } from 'react';
import Head from 'next/head';
import axios from 'axios';
import Thanks from './../../../components/Thanks';
import { Input, Input1, Textarea } from './../../../components/forms/input';
import ReCAPTCHA from 'react-google-recaptcha';
const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = '6Le-UtseAAAAAGpB4ucUJNIvZslgvZXc77lRT3tG';

class OrderNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      activePlan: [],
      service: '',
      param1: 0,
      param2: 0,
      param3: 0,
      param4: 0,
      currency: 'usd',
      website: '',
      budget: '',
    };
    this.reRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.hideThanksModal = this.hideThanksModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  handleChange(param, value) {
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
      service: '',
    });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    location.reload();
  }
  onSubmit(e) {
    e.preventDefault();

    const token = this.reRef.current.getValue();

    if (token) {
      let that = this;
      let form_data = new FormData(e.target);
      for (let key in this.state.formdata) {
        form_data.append(key, this.state.formdata[key]);
      }
      form_data.append('country', this.props.country);
      form_data.append('service', this.state.service);

      let budgetPlans = '';
      const planObj = {
        1: 'Generating More Leads',
        2: 'Optimizing Conversion Rate',
        3: 'Increasing website traffic',
        4: 'Increasing brand awareness and visibility',
        5: 'Reducing the cost of customer acquisition',
        6: 'Launching into new markets',
      };
      if (this.state.activePlan.length > 0) {
        let final = [];
        this.state.activePlan.forEach((el, item) => {
          final.push(planObj[el]);
        });
        budgetPlans = final.join(',');
      }
      form_data.append('plan', budgetPlans);
      form_data.append('budget', this.state.budget);

      console.log(Array.from(form_data));

      // that.setState({ showThanks: true });
      document.body.style.overflow = 'hidden';
      axios.post('https://mailer.weprodigi.com/api/v1/order-now', form_data).then(response => {
        // that.setState({ loadedThanks: true });
        window.location.href = 'https://weprodigi.com/thank-you';
      });
    }
    this.reRef.current.reset();
  }
  formTotal = () => {
    const self = this;
    switch (self.props.currency) {
      case 'amd':
        self.setState({
          param1: '$1000-$3000',
          param2: '$3001-$7000',
          param3: '$7001-$10.000',
          param4: '$10.000+',
        });
        break;
      case 'AMD':
        self.setState({
          param1: '$1000-$3000',
          param2: '$3001-$7000',
          param3: '$7001-$10.000',
          param4: '$10.000+',
        });
        break;
      case 'usd':
        self.setState({
          param1: '$1000-$3000',
          param2: '$3001-$7000',
          param3: '$7001-$10.000',
          param4: '$10.000+',
        });
        break;
      case 'eur':
        self.setState({
          param1: '€1000-€3000',
          param2: '€3001-€7000',
          param3: '€7001-€10.000',
          param4: '€10.000+',
        });
        break;
      case 'gbp':
        self.setState({
          param1: '£1000-£3000',
          param2: '£3001-£7000',
          param3: '£7001-£10.000',
          param4: '£10.000+',
        });
        break;
      case 'rub':
        self.setState({
          param1: '₽1000-₽3000',
          param2: '₽3001-₽7000',
          param3: '₽7001-₽10.000',
          param4: '₽10.000+',
        });
        break;
      case 'aud':
        self.setState({
          param1: 'AU $1000 - AU $3000',
          param2: 'AU $3001 - AU $7000',
          param3: 'AU $7001 - AU $.000',
          param4: 'AU $10.000+',
        });
        break;
      case 'AUD':
        self.setState({
          param1: 'AU $1000 - AU $3000',
          param2: 'AU $3001 - AU $7000',
          param3: 'AU $7001 - AU $.000',
          param4: 'AU $10.000+',
        });
        break;
      case 'sgd':
        self.setState({
          param1: 'SG $1000 - SG $3000',
          param2: 'SG $3001 - SG $7000',
          param3: 'SG $7001 - SG $.000',
          param4: 'SG $10.000+',
        });
        break;
      case 'cad':
        self.setState({
          param1: 'CA $1000 - CA $3000',
          param2: 'CA $3001 - CA $7000',
          param3: 'CA $7001 - CA $.000',
          param4: 'CA $10.000+',
        });
        break;
      case 'nzd':
        self.setState({
          param1: 'NZ $1000 - NZ $3000',
          param2: 'NZ $3001 - NZ $7000',
          param3: 'NZ $7001 - NZ $.000',
          param4: 'NZ $10.000+',
        });
        break;
      default:
        break;
    }
  };
  componentDidMount() {
    this.setState({ service: new URL(location.href).searchParams.get('service') });
    this.setState({ website: new URL(location.href).searchParams.get('website') });
    this.setState({ budget: new URL(location.href).searchParams.get('budget') });
    this.setState(prevState => {
      let formData = Object.assign({}, prevState.formData);
      formData.website = new URL(location.href).searchParams.get('website');
      return { formData };
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const self = this;
    this.setState({ currency: nextProps.currency }, () => {
      self.formTotal();
    });
  }
  setActivePlans = el => {
    if (!this.state.activePlan.includes(el)) {
      this.state.activePlan.push(el);
    } else {
      this.state.activePlan.splice(this.state.activePlan.indexOf(el), 1);
    }
  };
  render() {
    const { activePlan } = this.state;
    return (
      <>
        <Head>
          <title>Paid Ad Services Request Form - Order Now | Prodigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/paid-advertising-services/order-now" />
          <meta
            name="description"
            content="Launch your paid advertising campaign with Prodigi. Order now to increase your brand visibility and effectively reach your target audience."
          />
          <meta property="og:url" content="https://weprodigi.com/paid-advertising-services/order-now" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Paid Ad Services Request Form - Order Now | Prodigi" />
          <meta
            property="og:description"
            content="Launch your paid advertising campaign with Prodigi. Order now to increase your brand visibility and effectively reach your target audience."
          />
        </Head>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/main-image-positions.png');
            background-position: center;
          }
        `}</style>
        <div className="relative w-full  h-300  overflow-hidden  bg-grid">
          <div className="container h-full">
            <div className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <h1 className="uppercase text-purple text-36 md:text-72 font-black leading-none">
                Order Now
                <span className="text-black text-24 md:text-36 mt-10 max-w-450 md:leading-[54px] leading-[36px] block">
                  PAID ADVERTISING SERVICES
                </span>
              </h1>
            </div>
          </div>
        </div>
        <div className="bg-white py-30">
          <div className="container">
            <form id="orderNowForm" method="POST" onSubmit={e => this.onSubmit(e)}>
              <div className="mt-20">
                <div className="mb-10">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Company Name*</p>
                      <div className="mb-10">
                        <Input type="text" name="company-name" bg="bg-gray-light" required={true} onChange={this.handleChange} id={'company'} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Company Website*</p>
                      <div className="mb-10">
                        {this.state.website && (
                          <Input1
                            type="text"
                            value={this.state.formdata.website}
                            name="website"
                            bg="bg-gray-light"
                            required={true}
                            onChange={this.handleChange}
                            id={'website'}
                          />
                        )}
                        {!this.state.website && (
                          <Input type="text" name="website" bg="bg-gray-light" required={true} onChange={this.handleChange} id={'website'} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-10">
                  <div className="grid grid-cols-1 gap-10">
                    <div className="grid grid-cols-1 gap-10">
                      <div>
                        <p className={'text-16 flex items-center flex-wrap text-purple mb-10'}>
                          What business needs would you like to cover with our help?
                        </p>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(1);
                              this.handleChange('plan', 'Generating More Leads');
                            }}
                            className={`${activePlan.includes(1) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Generating More Leads</span>
                            {activePlan.includes(1) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(2);
                              this.handleChange('plan', 'Optimizing Conversion Rate');
                            }}
                            className={`${activePlan.includes(2) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Optimizing Conversion Rate</span>
                            {activePlan.includes(2) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(3);
                              this.handleChange('plan', 'Increasing website traffic');
                            }}
                            className={`${activePlan.includes(3) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Increasing website traffic</span>
                            {activePlan.includes(3) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(4);
                              this.handleChange('plan', 'Increasing brand awareness and visibility');
                            }}
                            className={`${activePlan.includes(4) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Increasing brand awareness and visibility</span>
                            {activePlan.includes(4) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(5);
                              this.handleChange('plan', 'Reducing the cost of customer acquisition');
                            }}
                            className={`${activePlan.includes(5) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Reducing the cost of customer acquisition</span>
                            {activePlan.includes(5) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlans(6);
                              this.handleChange('plan', 'Launching into new markets');
                            }}
                            className={`${activePlan.includes(6) ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-gray-light items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Launching into new markets</span>
                            {activePlan.includes(6) && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-10">
                  <p className={'text-14 flex items-center flex-wrap text-purple font-bolder'}>Which best describes you business model?</p>

                  <div className="  flex-wrap  grid-cols-1 gap-10">
                    <div className="form-group   w-full">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id={'b2b_' + (this.props.id ? this.props.id : '')}
                          name="businessDescription"
                          value="B2B(Busines to Business)"
                          onChange={() => this.handleChange('businessDescription', 'B2B(Busines to Business)')}
                        />
                        <label htmlFor={'b2b_' + (this.props.id ? this.props.id : '')}> B2B(Busines to Business)</label>
                      </div>
                    </div>
                    <div className="form-group mr-5  w-full">
                      <div className="radio-item  ">
                        <input
                          type="radio"
                          id={'b2c_' + (this.props.id ? this.props.id : '')}
                          name="businessDescription"
                          value="B2C (Busines to Consumer)"
                          onChange={() => this.handleChange('businessDescription', 'B2C (Busines to Consumer)\n')}
                        />
                        <label htmlFor={'b2c_' + (this.props.id ? this.props.id : '')}> B2C (Busines to Consumer)</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-10">
                  <p className="text-14 mb-5 text-purple font-bolder">Is there anything specific we should know about your project?</p>
                  <div className="mb-10">
                    <Textarea
                      type="text"
                      name="description"
                      bg="bg-gray-light resize-none"
                      required={false}
                      rows={4}
                      onChange={this.handleChange}
                      placeholder="Background, requirements, budget, deadline, etc."
                    />
                  </div>
                </div>
                <div className="mb-10">
                  <div className="grid grid-col-1 md:grid-cols-3 gap-10">
                    <div>
                      <p className="text-14  mb-5 text-purple font-bolder">Your Name *</p>
                      <div className="mb-10">
                        <Input type="text" name="name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14  mb-5 text-purple font-bolder">Your Email *</p>
                      <div className="mb-10">
                        <Input type="text" name="email" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14  mb-5 text-purple font-bolder">Your Phone Number *</p>
                      <div className="mb-10">
                        <Input type="number" name="phone-number" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-[10px] my-10">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-black text-14 md:text-18 flex items-center">
                      <input
                        id="nda"
                        className="absolute cursor-pointer opacity-0"
                        onChange={e => this.handleChange('nda', e.target.checked ? 'yes' : 'No')}
                        type="checkbox"
                        name="nda"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-black rounded-sm" />
                      Send NDA
                    </label>
                  </div>
                  <div className="flex flex-row my-10">
                    <ReCAPTCHA sitekey={NEXT_PUBLIC_RECAPTCHA_SITE_KEY} size={'normal'} ref={this.reRef} />
                  </div>
                </div>
                <input type="hidden" name="country" value={this.props.country} />
                <div className="col-span-2">
                  <button
                    id="offer-submit"
                    type="submit"
                    className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default OrderNow;
